import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CartArrowUp",
  "use": "CartArrowUp-usage",
  "viewBox": "0 0 9 12",
  "content": "<symbol viewBox=\"0 0 9 12\" id=\"CartArrowUp\">\n  <g transform=\"translate(-9, -7)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n    <g id=\"CartArrowUp_Path\">\n      <polygon transform=\"translate(13.5, 13) rotate(-90) translate(-13.5, -13) \" points=\"12.6272727 17 12.6272727 14 19 14 19 12 12.6272727 12 12.6272727 9 8 13\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol